import instance from "./axios";

//溢价成交资产列表接口（分页）
export const premiumList = (para) => {
  return instance.get('/premium/deal/asset/list', {params: para})
}
//溢价成交分析接口
export const premiumStatistics = (para) => {
    return instance.get('/deal/premium/statistics', {params: para})
  }
